var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import moment from "moment";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import { EErrorCodes, EInvestmentType, MfStatus, MFStatusDisplay, OrderDetailsDisplay, } from "./MutualFundConstant";
import { accountDetails } from "@mainDi/webDi";
import { EMutualFundFlow, getObjectFromInvestmentType, } from "./MutualFund";
import { EValueType } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import OrderModifiedSuccess from "@frameworks/shared-library/assets/images/SalesJourney/order-modified.svg";
import { EOrderBookStatus } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import { EHoldingType, } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import { roundUpToTwoDecimalPlaces } from "@domains/utils/numberMethods";
var getCommonPayloadForModifyAndPurchase = function (clientDetails, mfData, investmentType, purchaseFormData, allmfData, physicalFlg) { return __awaiter(void 0, void 0, void 0, function () {
    var investmentObject;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                investmentObject = getObjectFromInvestmentType(investmentType, mfData, investmentType === EInvestmentType.SIP
                    ? purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency
                    : "MONTHLY");
                _a = {
                    token: investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.token
                };
                return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
            case 1:
                _a.requestedBy = _b.sent();
                return [4 /*yield*/, accountDetails.getUserLoginType()];
            case 2: return [2 /*return*/, (// need change logic
                _a.loginType = _b.sent(),
                    _a.clientCode = clientDetails.clientCode,
                    _a.schemeCode = mfData === null || mfData === void 0 ? void 0 : mfData.schemeCode,
                    _a.isin = investmentObject === null || investmentObject === void 0 ? void 0 : investmentObject.isin,
                    _a.txnTyp = investmentType,
                    _a.amt = Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount),
                    _a.reInvFlg = mfData === null || mfData === void 0 ? void 0 : mfData.reInvFlag,
                    _a.ordTyp = "FRESH",
                    _a.schemeName = mfData === null || mfData === void 0 ? void 0 : mfData.schemeName,
                    _a.ordSrc = "RM_WEB",
                    _a.schemePlan = allmfData.shmplan,
                    _a.physicalFlag = physicalFlg,
                    _a.ucc = clientDetails.uniqueClientId,
                    _a.groupCode = allmfData.groupCode,
                    _a.returnType = investmentType === "SIP" ? mfData === null || mfData === void 0 ? void 0 : mfData.returnType : "",
                    _a)];
        }
    });
}); };
var setTimeoutID = null;
var investmentServices = {
    modify: {
        getRequestPayloadAsPerInvestmentTypes: function (mfData, clientDetails, allmfData, physicalFlg, investmentType, purchaseFormData, selectedMandate, selectedFolio) {
            return __awaiter(this, void 0, void 0, function () {
                var updatedPayload, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = [{}];
                            return [4 /*yield*/, getCommonPayloadForModifyAndPurchase(clientDetails, mfData, investmentType, purchaseFormData, allmfData, physicalFlg)];
                        case 1:
                            updatedPayload = __assign.apply(void 0, _a.concat([(_b.sent())]));
                            switch (investmentType) {
                                case EInvestmentType.LUMPSUM:
                                    updatedPayload.txnTyp = EInvestmentType.LUMPSUM.toUpperCase();
                                    break;
                                case EInvestmentType.SIP:
                                    updatedPayload = __assign(__assign({}, updatedPayload), { frequency: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipFrequency, startDt: moment(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate, "DD MMM YYYY").format("YYYY-MM-DD"), startDay: Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate.split(" ")[0]), txnTyp: "XSIP", generateToday: purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.firstInstallment, mandateId: selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.mandateId, mandateEndDate: selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.expiryDate, mandateAmount: selectedMandate === null || selectedMandate === void 0 ? void 0 : selectedMandate.amount });
                                    break;
                                case EInvestmentType.REDEEM:
                                    updatedPayload.txnTyp = "R";
                                    updatedPayload.amt = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.amount);
                                    if ((purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity) > 0) {
                                        updatedPayload.unit = +(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.quantity);
                                    }
                                    else {
                                        updatedPayload.unit = +roundUpToTwoDecimalPlaces(Number(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.redeemAmount) / +selectedFolio.nav);
                                    }
                                    if (physicalFlg === EHoldingType.Physical)
                                        updatedPayload.folioNum = selectedFolio.folioNo;
                                    break;
                            }
                            return [2 /*return*/, updatedPayload];
                    }
                });
            });
        },
        submit: function (props) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function () {
                var payload, data, _f, genericDetails, genericDetailsCollapse, error_1, errCode, getErrorJSON, _g, genericDetails, genericDetailsCollapse, errMessage, displayErr;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            props.hendleScreenState(EMutualFundFlow.LOADER);
                            if (setTimeoutID)
                                clearTimeout(setTimeoutID);
                            return [4 /*yield*/, this.getRequestPayloadAsPerInvestmentTypes(props.mfData, props.clientDetails, props.allmfData, props.physicalFlg, props.investmentType, props.purchaseFormData, props.selectedMandate, props.selectedFolio)];
                        case 1:
                            payload = _h.sent();
                            payload = __assign(__assign(__assign(__assign({}, payload), { trxId: String((_a = props.externalData.modifyData) === null || _a === void 0 ? void 0 : _a.trxId) }), (((_b = props.mfmodifyData) === null || _b === void 0 ? void 0 : _b.displayTransactionType) ===
                                EInvestmentType.SIP && {
                                vendorTrxId: (_c = props.externalData.modifyData) === null || _c === void 0 ? void 0 : _c.vendorTrxId,
                            })), { registrationNumber: (_e = (_d = props.externalData) === null || _d === void 0 ? void 0 : _d.modifyData) === null || _e === void 0 ? void 0 : _e.registrationNumber, 
                                // generateToday remains N in case of modify
                                generateToday: props.isModify &&
                                    props.mfmodifyData.displayStatus === EOrderBookStatus.ACTIVE
                                    ? "N"
                                    : props.purchaseFormData.firstInstallment, ordTyp: "MODIFY", returnType: props.mfData.returnType });
                            _h.label = 2;
                        case 2:
                            _h.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, tocDi.tocJourney.mfModifyOrder(payload)];
                        case 3:
                            data = _h.sent();
                            _f = __read(OrderDetailsDisplay(props.investmentType, payload, props.mfData, undefined, data, undefined, true), 2), genericDetails = _f[0], genericDetailsCollapse = _f[1];
                            props.setOrderStatus(__assign(__assign({}, MFStatusDisplay[EInvestmentType.MODIFY_ORDER][MfStatus.SUCCESS]), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse }));
                            setTimeoutID = setTimeout(function () { return props.hendleScreenState(EMutualFundFlow.ORDER_STATUS); }, 500);
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _h.sent();
                            errCode = error_1.getErrorCode();
                            getErrorJSON = this.parseError(error_1);
                            props.setServerError(getErrorJSON);
                            _g = __read(OrderDetailsDisplay(props.investmentType, payload, props.mfData, null, undefined, true, true), 2), genericDetails = _g[0], genericDetailsCollapse = _g[1];
                            errMessage = typeof getErrorJSON === "string"
                                ? getErrorJSON
                                : getErrorJSON
                                    .map(function (z, i) { return "".concat(i + 1, ".").concat(z.msg); })
                                    .join();
                            displayErr = errMessage
                                ? __assign({}, MFStatusDisplay[EInvestmentType.MODIFY_ORDER][MfStatus.FAILED]) : MFStatusDisplay[EInvestmentType.MODIFY_ORDER][MfStatus.FAILED];
                            if (errCode === EErrorCodes.ER1014) {
                                displayErr.description = error_1.getErrorMessege();
                            }
                            props.setOrderStatus(__assign(__assign({}, displayErr), { genericDetails: genericDetails, genericDetailsCollapse: genericDetailsCollapse }));
                            setTimeoutID = setTimeout(function () { return props.hendleScreenState(EMutualFundFlow.ORDER_STATUS); }, 500);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        parseError: function (error) {
            try {
                return JSON.parse(error === null || error === void 0 ? void 0 : error.getErrorMessege());
            }
            catch (_a) {
                return error === null || error === void 0 ? void 0 : error.getErrorMessege();
            }
        },
        confirmationScreen: function (props) {
            var _a, _b;
            if (setTimeoutID)
                clearTimeout(setTimeoutID);
            var genericDetails = __spreadArray(__spreadArray([
                {
                    label: "Next ".concat(props.investmentType === EInvestmentType.SIP
                        ? "SIP Instalment"
                        : props.investmentType, " amount"),
                    value: Number((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.amount),
                    valueType: EValueType.CURRENCY,
                }
            ], __read((props.investmentType === EInvestmentType.SIP
                ? [
                    {
                        label: "New SIP Date",
                        value: moment(props.purchaseFormData.sipDate).format("DD MMM YYYY"),
                    },
                ]
                : [])), false), __read((props.investmentType === EInvestmentType.SIP
                ? [
                    {
                        label: "New Mandate",
                        value: (_b = props.selectedMandate) === null || _b === void 0 ? void 0 : _b.mandateId,
                    },
                ]
                : [])), false);
            props.setOrderStatus({
                title: "Confirm your modified order.",
                icon: OrderModifiedSuccess,
                genericDetails: genericDetails,
            });
            setTimeoutID = setTimeout(function () {
                props.hendleScreenState(EMutualFundFlow.CONFIRM_ORDER);
            }, 500);
        },
    },
};
export default investmentServices;
